import { CLIENTID } from "./constant";
import { uniIdLoginUrl } from "./url";

export function isNotNull(data) {
  if (
    data !== undefined &&
    data !== null &&
    JSON.stringify(data) != "{}" &&
    data !== "undefined"
  ) {
    return true;
  }
  return false;
}

export function loginByUniId() {
  // let urlString =
  //   uniIdLoginUrl +
  //   "?clientId=" +
  //   CLIENTID +
  //   "&redirectUri=https://u-win.la/home/fromUniID" +
  //   "&use_callback_uri=true&isFromWeb=true";
  let urlString =
    uniIdLoginUrl +
    `?client_id=${CLIENTID}&redirect_uri=${"https://u-win.la/home/fromUniID"}&use_callback_uri=true`;
  window.open(urlString, "_self", "noopener,noreferrer");
  // window.open("/login", '_self', 'noopener,noreferrer');
}

export const eventAuctionSubmitBus = {
  on(event, callback) {
    document.addEventListener(event, (e) => callback(e.detail));
  },
  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event, callback) {
    document.removeEventListener(event, callback);
  },
};

export function diffHours(dt2, dt1) {
  var diff = (dt2 - dt1) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.floor(diff));
}

export function diffMinutes(dt2, dt1) {
  var diff = (dt2 - dt1) / 1000;
  diff /= 60;
  return Math.abs(Math.floor(diff));
}

export function diffSeconds(dt2, dt1) {
  var diff = (dt2 - dt1) / 1000;
  // diff /= 60;
  return Math.abs(Math.floor(diff));
}

export function addDayToTimeNow(numDay) {
  var ms = new Date().getTime() + numDay * 86400000;
  return new Date(ms);
}

export function convertDateToString(dateNow) {
  let year = dateNow.getYear() + 1900;
  let month = dateNow.getMonth() + 1;
  let day = dateNow.getDate();

  return (
    (day < 10 ? "0" + day : day) +
    "/" +
    (month < 10 ? "0" + month : month) +
    "/" +
    year
  );
}

export function getFirstDayOfWeek(weekNum) {
  var curr = new Date();

  let firstday = addDayToTimeNow(weekNum * 7 - curr.getDay());

  let year = firstday.getYear() + 1900;
  let month = firstday.getMonth() + 1;
  let day = firstday.getDate();

  return (
    (day < 10 ? "0" + day : day) +
    "/" +
    (month < 10 ? "0" + month : month) +
    "/" +
    year
  );
}

export function getLastDayOfWeek(weekNum) {
  var curr = new Date();

  let firstday = addDayToTimeNow(weekNum * 7 - curr.getDay() + 6);

  let year = firstday.getYear() + 1900;
  let month = firstday.getMonth() + 1;
  let day = firstday.getDate();

  return (
    (day < 10 ? "0" + day : day) +
    "/" +
    (month < 10 ? "0" + month : month) +
    "/" +
    year
  );
}

export function getFirstDayOfMonth(monthNum) {
  console.log("monthNum:  " + monthNum);
  var curr = new Date();
  curr.setMonth(curr.getMonth() + parseInt(monthNum) + 1);
  let year = curr.getYear() + 1900;

  let month = curr.getMonth();
  if (month === 0) {
    month = 12;
    year--;
  }
  console.log("getMonth: " + curr.getMonth() + " monthNum: " + monthNum);
  return (month < 10 ? "0" + month : month) + "/" + year;
}
